import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  getQuestionsAndAnswers,
  selectAppraisal
} from "../../../store/selectors";
import useBodyworkQuestionCompact from "../hooks/useBodyworkQuestionCompact";

interface AnswerObject {
  id: number;
  label: string;
}

interface IBodyworkQuestionCompactProps {
  question: Question;
  subtitle: string;
}

export const BodyworkQuestionCompact = ({
  question,
  subtitle
}: IBodyworkQuestionCompactProps) => {
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const { conditionalAnswersSubmitted } = useSelector(selectAppraisal);

  const {
    noDamage,
    handleChange,
    sortedAnswersForSelect,
    answer,
    labelForSelect,
    groupName,
    questionString,
    noDamageLabel,
    showSelectLabel,
    showSelectValue
  } = useBodyworkQuestionCompact({ question });

  const [toggleSelect, setToggleSelect] = useState(
    (storedAnswer && storedAnswer[0] === showSelectValue) ||
      (storedAnswer && storedAnswer[0] !== noDamage)
      ? true
      : false
  );
  const isAnswerSubmitted = conditionalAnswersSubmitted.includes(question.id);
  const radioError = !storedAnswer && isAnswerSubmitted;
  const selectError =
    storedAnswer && storedAnswer[0] === showSelectValue && isAnswerSubmitted;
  return (
    <>
      <div className="ch-pb--6 bodywork-question">
        <h3 className="ch-text--normal ch-pb--3">{subtitle}</h3>
        <p className="ch-width--12 ch-form__control-label ch-mb--2">
          {questionString}
        </p>

        <div className="ch-form__group">
          {radioError && (
            <div className="ch-form__group ch-form__group--error ch-mb--0">
              <span className="ch-form__control-validation ch-mb--1">
                Please choose an option
              </span>
            </div>
          )}
          <div className="ch-display--flex ch-flex-flow--column-nowrap sm:ch-flex-flow--row-nowrap">
            <div>
              <input
                id={`${groupName}-no`}
                type="radio"
                name={`${groupName}NeedRepaired`}
                value={noDamage}
                className="ch-radio"
                checked={
                  Boolean(answer) && Boolean(noDamage) && answer[0] === noDamage
                }
                onChange={({ target: { value } }) => {
                  setToggleSelect(false);
                  handleChange(parseInt(value));
                }}
              />
              <label
                htmlFor={`${groupName}-no`}
                className="ch-radio__label ch-radio__label--primary ch-width--12 sm:ch-width--auto"
              >
                {noDamageLabel}
              </label>
            </div>

            <div>
              <input
                id={`${groupName}-yes`}
                type="radio"
                name={`${groupName}NeedRepaired`}
                value={showSelectValue}
                className="ch-radio"
                checked={
                  (answer && answer[0] === showSelectValue) ||
                  (Boolean(answer) &&
                    Boolean(noDamage) &&
                    answer[0] !== noDamage)
                }
                onChange={({ target: { value } }) => {
                  setToggleSelect(true);
                  handleChange(parseInt(value));
                }}
              />
              <label
                htmlFor={`${groupName}-yes`}
                className="ch-radio__label ch-radio__label--primary sm:ch-ml--2 ch-mt--2 sm:ch-mt--0 ch-width--12 sm:ch-width--auto"
              >
                {showSelectLabel}
              </label>
            </div>
          </div>
        </div>

        {toggleSelect && (
          <div
            className={`ch-form__group ${
              selectError ? "ch-form__group--error" : ""
            }`}
          >
            <label
              htmlFor={`${groupName}Damaged`}
              className="ch-form__control-label"
            >
              {labelForSelect}
            </label>
            {selectError && (
              <span className="ch-form__control-validation">
                Please choose an option
              </span>
            )}
            <select
              name={`${groupName}Damaged`}
              className="ch-form__control custom-dropdown ch-color--grey-6"
              onChange={({ target: { value } }) =>
                handleChange(parseInt(value))
              }
              value={answer[0]}
            >
              <option value="">Select an option</option>
              {sortedAnswersForSelect.map((answerObject: AnswerObject) => (
                <option key={answerObject.id} value={answerObject.id}>
                  {answerObject.label}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </>
  );
};
